export var UTILITY = {
  Date: 'M/d/y',
  DateTime: 'M/d/y, h:mm a',
  DisplayDate: 'dd-MMM-yyyy',
  ISODate: 'yyyy-MM-dd'
}
